import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBell } from 'react-icons/fa';
import styled from 'styled-components';

import { UnReadCountLabel } from './UnReadCountLabel';

export type Props = {
  unreadCount: number;
  markArticlesAsRead: () => void;
};

export const Announcement: React.FC<Props> = ({
  unreadCount,
  markArticlesAsRead,
}) => {
  const { t } = useTranslation();
  return (
    <AnnouncementLink
      className="announcement"
      href={t('pages.external.announcement.url')}
      onClick={markArticlesAsRead}
      rel="noopener noreferrer"
      target="_blank"
    >
      {unreadCount > 0 && <UnReadCountLabel unreadCount={unreadCount} />}

      <StyledFaBell />
    </AnnouncementLink>
  );
};

const AnnouncementLink = styled.a`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.87);
  text-decoration: none;
  cursor: pointer;
  height: 64.2px;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
`;

const StyledFaBell = styled(FaBell)`
  font-size: 1.5rem;
  margin-right: 7.5px;
`;
